<template>

  <div class="page-queue-stats" style="overflow: auto;">
    <resize-observer @notify="__resizeHandler"/>
    <el-tabs v-model="activeTab">
      <el-tab-pane name="QueueActivity" label="Queue Activity">
        <queue-trend-plot
          ref="queueTrend"
          :queue-options="queueOptions"
          @waveReady="runTableQueries"
        />
      </el-tab-pane>
      <el-tab-pane name="QueueSummary" label="Queue Summary">
        <queue-summary
          ref="queueSummaryTable"
          :queue-options="queueOptions"
        />
      </el-tab-pane>
      <el-tab-pane name="AgentActivity" label="Agent Activity">
        <agent-activity
          ref="agentActivityTable"
          :queue-options="queueOptions"
        />
      </el-tab-pane>
      <el-tab-pane name="queueLog" label="Queue Log">
        <queue-log
          ref="queueLogTable"
          :queue-options="queueOptions"
        />
      </el-tab-pane>
    </el-tabs>
  </div>

</template>

<script>

import QueueTrendPlot from './components/queue-trend-plot';
import QueueSummary from './components/queue-summary-table';
import AgentActivity from './components/agent-activity-table';
import QueueLog from './components/queue-log-table';
import {mapActions} from "vuex";

export default {
  name: 'QueueStats',
  components: {QueueSummary, QueueTrendPlot, AgentActivity, QueueLog},
  data() {
    return {
      activeTab: 'QueueActivity',
      resized: false,
      queueOptions: []
    }
  },
  computed: {
    user(){
      return this.$store.state.auth.user;
    },
    selectedTenant(){
      return this.$store.state.selectedTenant;
    }
  },
  watch: {
    selectedTenant(){
      this.queryQueues();
    },
    activeTab(){
      if(this.activeTab === 'QueueActivity'){
        setTimeout(() => {
          this.$refs.queueTrend.chart.resize();
        }, 150);
      }
    }
  },
  methods: {
    ...mapActions('queues', {findQueues: 'find'}),
    async queryQueues(){
      const {userRole, adminQueues, enableReporting} = this.user;

      this.queueOptions = +userRole === 7 && !enableReporting
        ? await this.findQueues({query: {id: {$in: adminQueues}, tenantId: this.selectedTenant.id, $sort: {name: 1}}})
        : await this.findQueues({query: {tenantId: this.selectedTenant.id, $sort: {name: 1}}});
    },
    __resizeHandler: _.throttle(function (e) {
      if (this.resized) {
        setTimeout(() => {
          this.$refs.queueTrend.chart.resize();
        }, 1000)
      }
      this.resized = true;
    }, 700),
    runTableQueries(){
      this.$refs.queueSummaryTable.resetTable(true);
      this.$refs.queueLogTable.resetTable();
      this.$refs.agentActivityTable.resetTable(true);
    }
  },
  mounted(){
    this.queryQueues();
  }
}

</script>
